import React, { useState, useContext, useEffect } from 'react'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import AuthContext from '@/product/context/auth/authContext'
import InvoiceCard from '@/custom/components/molecules/InvoiceCard'
import NoRecordsFound from '@/custom/components/atoms/NoRecordsFound'
import { Pagination } from '@material-ui/lab'
import DashboardLayout from '@/views/Dashboard/DashboardLayout'
import CustomTable from '@/product/components/molecules/CustomTable'
import * as Yup from 'yup'
import {
    dateTimeFormatFunction,
    capitalize,
    paymentTypeRosoom,
    handleRedirectInternal,
    currencyFormat,
} from '@/custom/common/components'
import { useHistory } from 'react-router-dom'
import ProductContext from '@/product/context/product/productContext'
import { Button } from '@material-ui/core'
import { useFormik } from 'formik'
import SEO from '@/utils/SEO'
import Card from '@material-ui/core/Card'
import Box from '@material-ui/core/Box'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/custom/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import AlertContext from '@/product/context/alert/alertContext'
import PickupManage from '@/views/PickUp/manage'
import SchedulePickupContext from '@/product/context/schedulePickup/schedulePickupContext'
import CheckIn from '@/product/components/species/components/pickup/checkin'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import CommonContext from '@/custom/context/common/commonContext'

const bull = (
    <Box component="span" sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}>
        •
    </Box>
)

const MyPickup = (props) => {
    let [viewProduct, setViewProduct] = useState([])
    let [lotDetails, setLotDetails] = useState([])
    const [tableBody, setTableBody] = useState([])
    const [pickupPopup, setPickupPopup] = useState(false)
    const [invoiceId, setInvoiceId] = useState('')
    const [schedId, setSchedId] = useState('')
    const [paidDate, setPaidDate] = useState('')
    const [checkPopup, setCheckPopup] = useState(false)
    const [reload, setReload] = useState(false)
    const [locationId, setLocationId] = useState('')
    const authContext = useContext(AuthContext)
    const invoiceContext = useContext(InvoiceContext)
    const { search_alluserinvoices, getAllUserInvoices } = invoiceContext
    const scheduleContext = useContext(SchedulePickupContext)
    const { getSchedulePickupTiming, schedule_data, responseStatus, clearResponse } =
        scheduleContext
    const customCommonContext = useContext(CustomCommonContext)
    const { setCurrentMembership, allBiddingPlan, membership, alldata_all_dropdown, allLocations } =
        customCommonContext
    const commonContext = useContext(CommonContext)
    const { allConfigurationVariables } = commonContext

    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const productContext = useContext(ProductContext)
    const {
        search_alldashboardproducts,
        getAllDashboardProducts,
        responseStatus: responseStatusProduct,
    } = productContext
    const { user, isAuthenticated } = authContext
    const [isLoading, setIsLoading] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    let propsAction = props.match.params.action
    const history = useHistory()

    const formikSearch = useFormik({
        initialValues: {
            limit: 12,
            page: 1,
            orderby: 'b.common_invoice,desc',
            order: '',
            scheduled: 0,
            auctionView: 'Grid',
            filters: {
                invoice_id: {
                    value: '',
                    type: 'null',
                    field: 'spu.invoice_id',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'p.id,p.desc_proc,b.common_invoice',
                },
                status: {
                    value: '',
                    type: 'in',
                    field: 'spu.schedule_status',
                },
                returned: {
                    value: '0',
                    type: 'in',
                    field: 'b.returned',
                },
                // market_status: {
                //     value: ['sold', 'closed'],
                //     type: 'array',
                //     field: 'p.market_status',
                // },
                // delivery_type: {
                //     value: 'local_pickup',
                //     type: 'in',
                //     field: 'b.delivery_type',
                // },
                // searchbar: {
                //     value: '',
                //     type: 'like',
                //     field: 'p.title,p.desc_proc',
                // },
                // pickup_status: {
                //     value: 'pending',
                //     type: 'in',
                //     field: 'b.pickup_status',
                // },
            },
            action: 'won',
        },
    })

    useEffect(() => {
        if (propsAction == 'pending') {
            formikSearch.values.filters.searchterm.value = ''
            formikSearch.values.scheduled = 0
            formikSearch.values.filters.status.type = 'notin'
            formikSearch.values.filters.invoice_id.type = 'null'
            formikSearch.values.filters.status.value = ''
            getSchedulePickupTiming(formikSearch.values, 'allSchedule')
        } else {
            formikSearch.values.filters.searchterm.value = ''
            formikSearch.values.filters.invoice_id.type = 'notnull'
            formikSearch.values.filters.status.type = 'notin'
            formikSearch.values.filters.status.value = 'deleted'
            formikSearch.values.scheduled = 1
            getSchedulePickupTiming(formikSearch.values, 'allSchedule')
        }
    }, [propsAction])

    const validationArray = Yup.object({
        name: Yup.string().required('Required'),
        email: Yup.string().email('Invalid Email Format').required('Required'),
        phone: Yup.string()
            .trim()
            .min(10, 'Please enter correct mobile number')
            .max(10, 'Please enter correct mobile number')
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            invoice_id: '',
            user_id: '',
            location_id: '',
            name: '',
            email: '',
            phone: '+1',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {},
    })

    const handlePickup = () => {
        setPickupPopup(!pickupPopup)
        setInvoiceId('')
        setReload(!reload)
    }

    const handleCheckPopup = () => {
        setCheckPopup(!checkPopup)
        setSchedId('')
        setReload(!reload)
    }

    useEffect(() => {
        if (isAuthenticated) {
            getSchedulePickupTiming(formikSearch.values, 'allSchedule')
        }
    }, [formikSearch.values, isAuthenticated])

    const onHandlePage = (event, value) => {
        formikSearch.setFieldValue('page', value)
    }

    useEffect(() => {
        if (schedule_data && schedule_data.from == 'allSchedule') {
            setViewProduct(schedule_data.records.length ? schedule_data.records : [])
            let allData = schedule_data.records.length ? schedule_data.records : []
            if (allData.length) {
                allData.map((data) => {
                    if (data.schedulepickup_location_id && data.schedulepickup_location_id !== '') {
                        data.schedule_location_id = data.schedulepickup_location_id
                        data.schedulepickup_location_id = allLocations
                            .filter(
                                (item) =>
                                    item.active == 1 && item.id == data.schedulepickup_location_id,
                            )
                            .map((data) => {
                                return data.full_address
                            })?.[0]
                    }

                    if (data.location && data.location !== '') {
                        data.location_id = data.location

                        data.location_name = allLocations
                            .filter((item) => item.active == 1 && item.id == data.location_id)
                            .map((data) => {
                                return data.full_address
                            })?.[0]
                    } else {
                        if (data.location_id && data.location_id !== '') {
                            data.location_name = allLocations
                                .filter((item) => item.active == 1 && item.id == data.location_id)
                                .map((data) => {
                                    return data.full_address
                                })?.[0]
                        }
                    }
                })

                setTableBody(allData)
            }
        }
    }, [schedule_data])

    useEffect(() => {
        setViewProduct([])
        setTableBody([])
        return () => {
            setViewProduct([])
            setTableBody([])
        }
    }, [])

    const searchInfo = {
        formik: formikSearch,
        data: [
            {
                label: 'Lot Id/Title/Invoice Id',
                placeholder: 'Enter Lot Id/Title/Invoice Id',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
        ],
    }

    const onClickEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/${id}`)
    }

    let tableValues = []

    tableValues.push({
        field: 'buynow_common_invoice',
        type: '',
        firstChild: false,
        sort: true,
        sortField: 'b.common_invoice',
        disablePadding: false,
        label: 'Invoice No',
    })

    tableValues.push(
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            sortField: 'p.id',
            disablePadding: false,
            label: 'Lot #',
        },
        {
            field: 'avatar',
            type: 'imagewithurl',
            folder: 'product',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Image',
        },
        {
            field: 'title',
            type: '',
            firstChild: false,
            sort: true,
            sortField: 'p.title',
            disablePadding: false,
            label: 'Name',
        },
    )
    if (propsAction == 'pending') {
        tableValues.push({
            field: 'location_name',
            type: '',
            firstChild: false,
            disablePadding: false,
            label: 'Location',
        })
    }

    if (propsAction !== 'pending') {
        tableValues.push(
            {
                field: 'schedulepickup_location_id',
                type: '',
                firstChild: false,
                disablePadding: false,
                label: 'Warehouse Location',
            },
            {
                field: 'schedulepickup_schedule_status',
                type: 'capitalize',
                firstChild: false,
                disablePadding: false,
                label: 'Pickup Status',
            },
        )
    }
    tableValues.push(
        {
            field: 'date_closed',
            type: 'datetime',
            firstChild: false,
            disablePadding: false,
            label: 'Date Closed',
        },
        {
            field: 'wprice',
            type: 'price',
            firstChild: false,
            disablePadding: false,
            label: 'Winning Bid',
        },
        {
            field: 'buynow_paid',
            type: 'condition',
            firstChild: false,
            disablePadding: false,
            label: 'Status',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'buynow_paid',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Paid',
                },
                false: {
                    type: 'text',
                    value: 'Unpaid',
                },
            },
        },
        {
            field: 'action',
            buttonType: 'visibility',
            clickType: 'viewStore',
            type: 'button',
            onclick: onClickEdit,
            sort: false,
            clickID: 'buynow_common_invoice',
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'View Invoice',
        },
    )

    const onSelectMultiProducts = (data, action) => {
        if (action == 'check') {
            setSchedId(data)
            let locId = []
            let status = []
            viewProduct.map((item) => {
                if (data.includes(item.schedulepickup_id)) {
                    if (!locId.includes(item.schedule_location_id)) {
                        locId.push(item.schedule_location_id)
                        status.push(item.schedulepickup_schedule_status)
                    }
                }
            })
            if (status.includes('completed') || status.includes('waiting')) {
                setAlert('Please select booking status invoices', 'error')
            } else if (locId.length > 1) {
                setAlert('Kindly Select same location', 'error')
            } else {
                setCheckPopup(true)
                if (locId.length) {
                    const location = allLocations.filter((item) => item.id == locId[0])
                    setLocationId(location[0].id)
                } else {
                    setLocationId('')
                }
            }
        } else {
            setInvoiceId(data)
            let locId = []
            viewProduct.map((item) => {
                if (data.includes(item.common_invoice)) {
                    if (!locId.includes(item.location_id)) {
                        setPaidDate(item.buynow_paid_date)
                        locId.push(item.location_id)
                    }
                }
            })
            if (locId.length > 1) {
                setAlert('Kindly Select same location', 'error')
            } else {
                setPickupPopup(true)
                if (locId.length) {
                    setLocationId(locId[0])
                } else {
                    setLocationId('')
                }
            }
        }
    }

    const tableActions = []

    if (props.match.params.action === 'pending') {
        tableActions.push({
            label: 'Schedule Pickup',
            icon: <span className="material-icons">local_shipping</span>,
            onclick: onSelectMultiProducts,
            clickId: 'common_invoice',
            type: 'open',
        })
    } else {
        tableActions.push({
            label: 'Check In',
            icon: <span className="material-icons">login</span>,
            onclick: onSelectMultiProducts,
            clickId: 'schedulepickup_id',
            secondaryClickID: 'schedulepickup_status',
            type: 'check',
        })
    }

    const getFunction = () => {
        getSchedulePickupTiming(formikSearch.values, 'allSchedule')
    }
    return (
        <>
            <SEO title="My Invoice" url={window.location.href} />
            <DashboardLayout title={'my schedule pickup'}>
                <div className="dashboardInner mySavedSearches">
                    <CustomSearch searchInfo={searchInfo} formik={formikSearch} />
                    <>
                        {viewProduct.length ? (
                            <>
                                <CustomTable
                                    formik={formikSearch.values}
                                    isLoading={isLoading}
                                    tableBody={tableBody}
                                    tableValues={tableValues}
                                    tableActions={tableActions}
                                    allData={schedule_data}
                                    clickId={
                                        props.match.params.action == 'pending'
                                            ? 'buynow_common_invoice'
                                            : 'schedulepickup_id'
                                    }
                                    changeTableFunction={getSchedulePickupTiming}
                                    fromVariable={'allSchedule'}
                                />
                            </>
                        ) : (
                            <NoRecordsFound />
                        )}
                        <PickupManage
                            pickPopup={pickupPopup}
                            handlePickup={handlePickup}
                            invoiceId={invoiceId}
                            getFunction={getFunction}
                            locationId={locationId}
                            paidDate={paidDate}
                            pickupDaysLimit={
                                allConfigurationVariables?.schedule_pickup_end_date
                                    ? allConfigurationVariables?.schedule_pickup_end_date
                                    : 0
                            }
                        />
                        <CheckIn
                            schedId={schedId}
                            checkPopup={checkPopup}
                            handleCheckPopup={handleCheckPopup}
                            getFunction={getFunction}
                            locationId={locationId}
                        />
                    </>
                </div>
            </DashboardLayout>
        </>
    )
}

export default MyPickup
